import { tsValidateString, tsValidateValue } from '@nu-art/ts-common';
import { smartDocStaticParamType_Time } from './types.js';
import { Validator_SmartDocStaticParamType } from '../_base/index.js';
import { Validator_SmartDocParamResolver_Time } from '../../../smart-doc-param-resolver/index.js';
export const Validator_SmartDocStaticParam_Time = {
    key: tsValidateString(),
    type: Validator_SmartDocStaticParamType,
    subType: tsValidateValue([smartDocStaticParamType_Time]),
    resolver: Validator_SmartDocParamResolver_Time,
};
//# sourceMappingURL=validator.js.map